<template lang="pug">
#legenda
    .item-legenda(v-for='(value, index) in values', :key='index')
        .icon-legenda
            .line(v-if='value.line', :style='{ backgroundColor: value.color }')
            .dash(
                v-if='value.dash',
                :style='{ border: `2px dashed ${value.color}` }'
            )
            .circle(
                v-if='value.circle',
                :style='{ backgroundColor: value.color }'
            )
        .titulo {{ value.name }}
</template>

<script>
export default {
    name: 'Legenda',

    props: {
        values: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss">
#legenda {
    position: absolute;
    display: flex;
    left: 10px;
    top: 10px;
    height: 25px;
    z-index: 1020;
    background-color: var(--white);
    @include border-radius(4px);

    .item-legenda {
        padding: 10px;
        display: flex;
        align-items: center;

        .icon-legenda {
            margin-right: 5px;

            .circle {
                @include box(10px);
                @include border-radius(50px);
                border: 1px solid var(--secondary);
            }

            .line {
                width: 20px;
                height: 2px;
            }

            .dash {
                width: 20px;
                height: 2px;
            }
        }
    }
}
</style>
